<template>
    <transition name="confirm-fade">
      <div v-if="isShowConfirm" class="my-confirm" @click.stop="hidden()">
        <div class="wrap" @click.stop>
          <div :class="['container', { 'container-dark': theme_dark }]">
            <h3 class="title">打招呼设置</h3>
            <span class="tips">一句有吸引力的打招呼，更容易收到对方的回复，赶快为自己设定一条招呼吧~</span>

            <ul class="select-block">
                <li class="item ub ub-pc ub-ac2" v-for="(i, index) in arr" :key="index" @click="choseItem(i)">
                    <div class="ub ub-pc">
                      <img v-if="i.on" src="../assets/img/radio.png" alt="">
                      <img v-if="!i.on"  src="../assets/img/no-radio.png" alt="">
                      <div class="ub ub-ver">
                        <span>{{ i.txt.length > 10 ? i.txt.substr(0,10) + '...' : i.txt }}</span>
                        <span class="tip" v-if="i.type == 'sys'">{{ i.tip }}</span>
                      </div>
                    </div>
                    <span class="del" @click="del(i)" v-if="i.type == 'custom'">删除</span>
                </li>

                <li class="ub">
                    <input type="text" v-if="show_input" v-model="inputValue" @input="handleInput" placeholder="请输入自定义打招呼内容...">
                </li>

                <div class="customize ub ub-ac ub-pc" v-if="!show_input" @click="customize()">
                    <div class="add ub ub-ac ub-pc">
                      <span>+</span>
                    </div>
                    <span>自定义</span>
                </div>
                
            </ul>

            <button class="btn-add" v-if="btn_state" @click="txt_ok()">添加</button>
            <button class="btn-ok" v-if="!btn_state" @click="confirm()">完成</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import { mapMutations, mapActions } from "vuex";
  import * as tool from "../api/common";
  export default {
    data() {
      return {
        isShowConfirm: false, // 用于控制整个窗口的显示/隐藏
        theme_dark: false,
        arr: [
            {
                txt: "使用系统随机打招呼",
                on: true,
                type: "sys",
                tip: "根据系统智能匹配"
            }
        ],
        show_input: false,
        inputValue: "",
        btn_state: false,
        from: ""
      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      init_page() {
        
      },
  
      show(from) {
        //切换深色模式
        this.theme_dark = tool.is_theme_dark(this);
        this.isShowConfirm = true;
        this.from = from;

        var loc_hello = JSON.parse(localStorage.getItem("loc_customize_hello")) || [];
        if (loc_hello.length > 0) {
            this.arr = loc_hello;
        } else {
          localStorage.setItem("loc_customize_hello", JSON.stringify(this.arr));
        }
      },
      hidden() {
        this.isShowConfirm = false;
        this.show_input = false;
        this.btn_state = false;
        this.$store.commit('set_objVal', {"is_set_sayHello":true});
      },

      choseItem(selectedItem) {
        for(var i in this.arr) {
            var item = this.arr[i];
            item.on = false;
        }
        selectedItem.on = true;
        this.btn_state = false;
      },

      //自定义
      customize() {
        this.show_input = true;
      },

      //完成自定义
      txt_ok() {
        if (tool.trim(this.inputValue) == "") {
          this.inputValue = "";
          this.$toast.center("内容不能为空");
          return false;
        }

        for (var i in this.arr) {
            var item = this.arr[i];
            item.on = false;
        }
        
        this.inputValue = tool.trim(this.inputValue);
        var obj = {
            "txt": this.inputValue,
            "on": true,
            "type": "custom",
        }
        this.arr.push(obj);
        this.inputValue = "";
        this.btn_state = false;
        this.show_input = false;
        localStorage.setItem("loc_customize_hello", JSON.stringify(this.arr));
      },

      handleInput() {
        this.btn_state = true;
      },

      //删除
      del(item) {
        this.arr = this.arr.filter(i => i !== item);
        if (this.arr.length > 0) {
          this.arr[0].on = true;
        }
      },

      //完成
      confirm() {
        localStorage.setItem("loc_customize_hello", JSON.stringify(this.arr));
        this.hidden();
        if (this.from == "设置") {
          this.$toast.center("设置成功");
          return false;
        }
        this.$emit('SetSuccess');
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .my-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
    /* 这里防止当用户长按屏幕，出现的黑色背景色块，以及 iPhone 横平时字体的缩放问题 */
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  
  /* 进入和出去的动画 */
  .confirm-fade-enter-active {
    animation: opacity 0.3s;
  }
  .confirm-fade-leave-active {
    animation: outOpacity 0.2s;
  }
  /* 进来的动画 */
  @keyframes opacity {
    0% {
      opacity: 0;
    }
  
    100% {
      opacity: 1;
    }
  }
  
  /* 出去的动画 */
  @keyframes outOpacity {
    0% {
      opacity: 1;
    }
  
    100% {
      opacity: 0;
    }
  }
  
  /* 包裹层容器样式 */
  .wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: 85%;
    margin: 0 auto;
    z-index: 999;
    border-radius: 1rem;
    user-select: none;
  }

  .container {
    padding: 0 0.8rem 0 0.8rem;
    border-radius: 1rem;
    background: linear-gradient(to bottom, #FE9CC0, #fff 3rem);
    .title {
        height: 3rem;
        line-height: 3rem;
        text-align: center;
        font-size: 1rem;
        font-weight: bold;
        color: #6C1AAB;
    }

    .tips {
        font-size: 0.75rem;
        color: #888;
    }

    .select-block {
        margin-top: 1rem;
        .item {
            margin-bottom: 0.5rem;
            .no-on {
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                background-color: #b5aaaa;
                font-size: 0.5rem;
                color: #fff;
            }
            img {
                width: 1rem;
                height: 1rem;
            }
            span {
                margin-left: 0.5rem;
                font-size: 1rem;
                color: #333;
            }
            .tip {
              font-size: 0.6rem;
              color: #888;
            }
            .del {
              font-size: 0.75rem;
              color: red;
            }
        }
        li input {
            width: 100%;
            padding: 0 0.5rem;
            height: 2rem;
            outline: none;
            border: 1px solid #9dcef7;
        }

        .item:first-child {
          margin-bottom: 1rem;
          img {
            margin-bottom: 0.6rem;
          }
        }
    }

    .customize {
      width: 8rem;
      height: 2rem;
      border: 1px solid rgb(186, 97, 255);
      border-radius: 0.2rem;
      z-index: 1;
        .add {
          margin-right: 0.2rem;
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          background-color: #c1c1c1;
          span {
            color: #333;
          }
        }
        span {
          font-size: 0.95rem;
          font-weight: bold;
          color: #333;
        }
    }

    .btn-add {
      margin-top: 2rem;
      margin-bottom: 1.5rem;
      padding: 0.6rem 0;
      width: 100%;
      border: none;
      border-radius: 2rem;
      background-image: linear-gradient(to bottom,#2cac32,#59e064);
      font-size: 1rem;
      color: #fff;
    }

    .btn-ok {
        margin-top: 2rem;
        margin-bottom: 1.5rem;
        padding: 0.6rem 0;
        width: 100%;
        border: none;
        border-radius: 2rem;
        background: linear-gradient( 90deg, #A264E7, #FE9CC0);  
        font-size: 1rem;
        color: #fff;
    }
  }


  .container-dark {
    background: linear-gradient(to bottom, #9c365c, #333 3rem);
    .title {
        color: #fff;
    }
    .select-block {
      .item {
        span {
          color: #fff;
        }
      }
    }
    .customize {
      span {
        color: #fff;
      }
    }
    li input {
      background-color: #333;
      color: #fff;
    }
  }
  </style>
  